export const defaultProfile = {
  name: 'Ayesha Tariq',
  email: 'ayesha@fitzone.com',
  phone: '+92 300 2233445',
  branch: 'Main Branch',
  shift: 'Morning',
};

export const defaultNotificationPrefs = {
  membershipExpiryAlerts: true,
  paymentAlerts: true,
  birthdayWishes: true,
  newMemberAlerts: false,
  visitorAlerts: true,
  dailySummary: true,
};

export const activityLog = [
  { id: '1', action: 'Registered new member', detail: 'Sara Ahmed — Basic package', time: '07:15 AM', date: '2026-07-05' },
  { id: '2', action: 'Collected payment', detail: 'Ali Khan — Rs 28,000 (Cash)', time: '09:15 AM', date: '2026-07-05' },
  { id: '3', action: 'Issued guest pass', detail: 'Hamza Siddiqui — GP-2026-0042', time: '08:30 AM', date: '2026-07-05' },
  { id: '4', action: 'Recorded check-in', detail: 'Fatima Noor — 08:00 AM', time: '08:00 AM', date: '2026-07-05' },
  { id: '5', action: 'Set follow-up reminder', detail: 'Mariam Qureshi — 2026-07-08', time: '09:45 AM', date: '2026-07-05' },
  { id: '6', action: 'Renewed membership', detail: 'Ali Khan — Premium', time: '10:00 AM', date: '2026-07-04' },
];
